export default {
  meta: {
    title: '开店区域推荐详情-地图',
  },
};
